/* OWR cart drawer — "You May Also Like" mini row.
   Fetches Shopify product recommendations for the first cart line
   whenever the drawer opens or the cart re-renders. */
(function () {
  'use strict';

  var lastProductId = null;

  function money(cents) {
    try {
      return 'Rs. ' + (cents / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 });
    } catch (e) {
      return 'Rs. ' + Math.round(cents / 100);
    }
  }

  function render(products) {
    var wrap = document.getElementById('OwrDrawerRecs');
    var row = document.getElementById('OwrDrawerRecsRow');
    if (!wrap || !row) return;
    if (!products || !products.length) { wrap.hidden = true; return; }
    row.innerHTML = products.slice(0, 4).map(function (p) {
      var img = p.featured_image ? p.featured_image + '&width=160' : '';
      if (img && img.indexOf('?') === -1) img = p.featured_image + '?width=160';
      return (
        '<a class="owr-drawer-rec" href="' + p.url + '">' +
          (img ? '<img src="' + img + '" alt="" loading="lazy" width="72" height="90">' : '') +
          '<span class="owr-drawer-rec__price">' + money(p.price) + '</span>' +
        '</a>'
      );
    }).join('');
    wrap.hidden = false;
  }

  function refresh() {
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) {
          render(null);
          lastProductId = null;
          return;
        }
        var pid = cart.items[0].product_id;
        if (pid === lastProductId) return; // already rendered for this product
        lastProductId = pid;
        var root = (window.Shopify && window.Shopify.routes) ? window.Shopify.routes.root : '/';
        return fetch(root + 'recommendations/products.json?product_id=' + pid + '&limit=6&intent=related')
          .then(function (r) { return r.json(); })
          .then(function (data) { render(data.products || []); })
          .catch(function () { render(null); });
      })
      .catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', function () {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    // refresh when the drawer opens
    var observer = new MutationObserver(function () {
      if (drawer.classList.contains('active') || drawer.classList.contains('animate')) refresh();
    });
    observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });

    // refresh after any cart mutation re-render (drawer body gets replaced)
    var body = document.getElementById('CartDrawer');
    if (body) {
      new MutationObserver(function () {
        if (drawer.classList.contains('active')) refresh();
      }).observe(body, { childList: true, subtree: true });
    }
  });
})();
